import React from 'react';

const NotFound = ({custom}) => {
    return (
        <div className="w3-container w3-animate-opacity">
            <h4> <b> Wait a minute...</b> </h4>
            <p> {custom ? custom : "We're trying to process your request. If taking longer than usual. Try refreshing or logging in again."} </p>
       </div>

    )
}

export default NotFound